<mat-slide-toggle
  [checked]="isDarkModeEnabled"
  (change)="toggleTheme()"
  [aria-label]="'Theme Switch'"
></mat-slide-toggle>
